import React from 'react';
import { Spin, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import intl from 'react-intl-universal';

import { parseFen2Yuan } from '@/utils/number';

import balanceImg from '@/assets/img/balance@2x.png';
import paymentImg from '@/assets/img/payment@2x.png';
import consumeImg from '@/assets/img/consume@2x.png';
import depositImg from '@/assets/img/deposit@2x.png';
import settledImg from '@/assets/img/settled.png';
import invoiceImg from '@/assets/img/invoiceAmount.png';

import styles from './index.module.scss';

function BillStats({ loading, billStats }) {
  return (
    <Spin spinning={loading}>
      <ul className={styles['bill-stats']}>
        <li>
          <img src={paymentImg} alt={intl.get('drawer_extension_picker_balance_label')} />
          <div>
            <p>{intl.get('drawer_extension_picker_balance_label')}</p>
            <strong>{parseFen2Yuan(billStats.realtimeBalance)}</strong>
            <p>{intl.get('bill_not_contain_deposit')}</p>
          </div>
        </li>
        <li>
          <img src={depositImg} alt={intl.get('app_reservation_deposit_amount')} />
          <div>
            <p>{intl.get('bill_available_deposit')}</p>
            <strong>{parseFen2Yuan(billStats.deposit)}</strong>
          </div>
        </li>
        <li>
          <img src={balanceImg} alt={intl.get('bill_pay_total')} />
          <div>
            <p>{intl.get('bill_pay_total_tip')}</p>
            <strong>{parseFen2Yuan(billStats.sum)}</strong>
            {billStats.otaPre && billStats.otaPre > 0 ? (
              <p>
                {intl.get('bill_part_settle_include_ota_advance')} {parseFen2Yuan(billStats.otaPre)}
              </p>
            ) : null}
          </div>
        </li>
        <li>
          <img src={consumeImg} alt={intl.get('bill_consume_total')} />
          <div>
            <p>{intl.get('bill_consume_total_tip')}</p>
            <strong>{parseFen2Yuan(billStats.totalConsumption)}</strong>
            {billStats.commodityFee && billStats.commodityFee > 0 ? (
              <p>
                {intl.get('bill_contains_goods_fee')} {parseFen2Yuan(billStats.commodityFee)}
              </p>
            ) : null}
          </div>
        </li>
        <li>
          <img src={settledImg} alt={intl.get('bill_has_paid')} />
          <div>
            <p>{intl.get('bill_has_paid')}</p>
            <strong>{parseFen2Yuan(billStats.knotMonies)}</strong>
          </div>
        </li>
        <li>
          <img
            src={invoiceImg}
            alt={intl.get('bill_invoice_history_invoice_should_invoice_amount')}
          />
          <div>
            <p>
              {intl.get('bill_invoice_history_invoice_should_invoice_amount')}
              <Tooltip
                title={
                  <>
                    <div>{intl.get('bill_invoice_should_amount')}</div>
                    <div>{intl.get('bill_invoice_unpaid_tip')}</div>
                  </>
                }
                placement="top"
              >
                <InfoCircleOutlined style={{ marginLeft: 4, color: '#DCDEE0' }} />
              </Tooltip>
            </p>
            <strong>{parseFen2Yuan(billStats.invoiceAmount)}</strong>
            <p>
              {intl.get('bill_transfer_unpaid')}{' '}
              {billStats.notInvoicedAmount < 0
                ? parseFen2Yuan(0)
                : parseFen2Yuan(billStats.notInvoicedAmount)}
            </p>
          </div>
        </li>
      </ul>
    </Spin>
  );
}

export default BillStats;
